export default [
    {
        field: 'subfamily',
        type: 'text',
        maxLength: 30,
        value: '',
        vuetifyProps: {
            label: 'Nombre de Subfamilia',
        },
        rules: ['required'],
        flex: {
            xs12: true,
        },
    },
]
